const videoContainers = document.querySelectorAll('[data-video-container]');

videoContainers.forEach((container, index) => {
	const video = container.querySelector('[data-video]');
	const toggleButton = container.querySelector('[data-video-toggle]');
	const playIcon = container.querySelector('[data-video-play-icon]');
	const pauseIcon = container.querySelector('[data-video-pause-icon]');

	if (toggleButton && video) {
		toggleButton.addEventListener('click', () => {
			if (video.paused) {
				video.play();
				playIcon.classList.add('hidden');
				pauseIcon.classList.remove('hidden');
			} else {
				video.pause();
				playIcon.classList.remove('hidden');
				pauseIcon.classList.add('hidden');
			}
		});
	}
});

const rows = document.querySelectorAll('.rows')
rows.forEach((row) => {
	const rowDatas = row.querySelectorAll('td')
	rowDatas.forEach((data, index) => {
		if (data.classList.contains('row-title')) return

		if (window.getComputedStyle(row).backgroundColor === 'rgb(241, 241, 236)') {
			data.classList.add('bg-grayWhite')
			data.classList.remove('bg-white')
		} else {
			data.classList.remove('bg-grayWhite')
			data.classList.add('bg-white')
		}
		if (index === rowDatas.length - 1) row.style.backgroundColor = '#FFF'
	})
})

const columnTitles = document.querySelectorAll('.product-detail-column-title')
let maxTitleHeight = -1
columnTitles.forEach((title) => {
	const currHeight = title.getBoundingClientRect().height
	if (currHeight > maxTitleHeight) maxTitleHeight = currHeight
})
columnTitles.forEach((title) => (title.style.minHeight = `${maxTitleHeight}px`))
